import React, { useEffect, useRef, useState } from "react";
import "../styles/FreeCourses.css";
import { FaBookReader, FaChalkboardTeacher, FaUserGraduate, FaBrain } from "react-icons/fa";
import CoursesImage from "../images/courses.jpg";
import KoranImage from "../images/koran.png"; // Import the decorative image

const FreeCourses = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  // Intersection Observer for visibility detection
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const courses = [
    // {
    //   icon: <FaBookReader />,
    //   title: "Angel Academy Curriculum",
    //   description: "Engaging and comprehensive resources tailored for young learners.",
    // },
    {
      icon: <FaChalkboardTeacher />,
      title: "Leadership Course",
      description: "One-hour weekly course focused on developing leadership in students.",
    },
    {
      icon: <FaUserGraduate />,
      title: "Islamic Pedagogy",
      description: "Explore Islamic educational principles, including sub-courses like Tarbiya.",
    },
    {
      icon: <FaBrain />,
      title: "Personal Development",
      description: "Integrating psychological principles with Islamic teachings for self-growth.",
    },
  ];

  return (
    <section className="free-courses-section" ref={sectionRef}>
      {/* Decorative Image */}
      {isVisible && (
        <img src={KoranImage} alt="Koran Decoration" className="koran-decoration" />
      )}
      <div className="free-courses-container">
        {/* Left Column: Text and Courses */}
        <div className={`courses-content ${isVisible ? "fade-in" : ""}`}>
          <h2 className="courses-heading">Explore Our Free Courses</h2>
          <p className="courses-subheading">
            Access high-quality, free courses designed to inspire growth and leadership, rooted in Islamic values.
          </p>
          <div className="courses-list">
            {courses.map((course, index) => (
              <div key={index} className="course-item">
                <div className="course-icon">{course.icon}</div>
                <div className="course-info">
                  <h3 className="course-title">{course.title}</h3>
                  <p className="course-description">{course.description}</p>
                </div>
              </div>
            ))}
          </div>
          <button className="explore-button">Explore All Courses</button>
        </div>

        {/* Right Column: Image */}
        <div className={`courses-image ${isVisible ? "fade-in-right" : ""}`}>
          <img src={CoursesImage} alt="Courses Illustration" />
        </div>
      </div>
    </section>
  );
};

export default FreeCourses;
